import QuestionsPage from './questions-page.connect'

export default QuestionsPage



// WEBPACK FOOTER //
// ./src/components/views/questions-page/index.js